import type { CheckoutState } from '../../state';
import { getCurrentTimezone } from '../app';
import { getEventTimezone, getIsEventOnline } from '../event';

export const getActiveSection = (state: CheckoutState) =>
    state.infiniteCalendarSeries.activeSection;

export const getParentEventInfo = (state: CheckoutState) =>
    state.infiniteCalendarSeries.parentEventInfo;

export const getCalendarData = (state: CheckoutState) =>
    state.infiniteCalendarSeries.calendarData;

export const getCalendarType = (state: CheckoutState) =>
    state.infiniteCalendarSeries.calendarType;

export const getTimeSlots = (state: CheckoutState) =>
    state.infiniteCalendarSeries.timeSlots;

export const getIsDateSectionLoading = (state: CheckoutState) =>
    state.infiniteCalendarSeries.isDateSectionLoading;

export const getIsTimeSectionLoading = (state: CheckoutState) =>
    state.infiniteCalendarSeries.isTimeSectionLoading;

export const getIsTicketSectionLoading = (state: CheckoutState) =>
    state.infiniteCalendarSeries.isTicketSectionLoading;

export const getShouldShowTimeError = (state: CheckoutState) =>
    state.infiniteCalendarSeries.shouldShowTimeError;

export const getShouldShowTicketError = (state: CheckoutState) =>
    state.infiniteCalendarSeries.shouldShowTicketError;

export const getSelectedDate = (state: CheckoutState) =>
    state.infiniteCalendarSeries.selectedDate;

export const getSelectedTime = (state: CheckoutState) =>
    state.infiniteCalendarSeries.selectedTime;

export const getShouldShowTimeSection = (state: CheckoutState) =>
    state.infiniteCalendarSeries.shouldShowTimeSection;

export const getTimezone = (state: CheckoutState) =>
    getIsEventOnline(state)
        ? getCurrentTimezone(state) ||
          Intl.DateTimeFormat().resolvedOptions().timeZone
        : getEventTimezone(state);
